import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=015db6f4&scoped=true"
import script from "./Inquiries.vue?vue&type=script&lang=ts"
export * from "./Inquiries.vue?vue&type=script&lang=ts"
import style0 from "./Inquiries.vue?vue&type=style&index=0&id=015db6f4&prod&scoped=true&lang=css"
import style1 from "./Inquiries.vue?vue&type=style&index=1&id=015db6f4&prod&scoped=true&lang=scss"
import style2 from "./Inquiries.vue?vue&type=style&index=2&id=015db6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015db6f4",
  null
  
)

export default component.exports